export default(key, lang) => {
  let mapping = {
    backToLoginPage: {
      en_US: 'Back To Login Page',
      de_DE: 'Zurück zur Anmeldeseite',
      el_GR: 'Επιστροφή στη σελίδα σύνδεσης',
      es_ES: 'Volver a la página de inicio de sesión',
      fr_FR: 'Retour à la page de connexion',
      fr_CA: 'Retour à la page de connexion',
      it_IT: 'Torna alla pagina di accesso',
      pl_PL: 'Powrót do strony logowania',
      th_TH: 'กลับสู่หน้าเข้าสู่ระบบ',
      zh_CN: '返回登錄頁面',
      pt_BR: 'Voltar à página de login',
      ja_JP: 'ログインページに戻る',
    },
    contactAdmin: {
      en_US: 'Contact Your Admin',
      de_DE: 'Wenden Sie sich an Ihren Admin',
      el_GR: 'Επικοινωνήστε με το διαχειριστή σας',
      es_ES: 'Póngase en contacto con su administrador',
      fr_FR: 'Contactez votre administrateur',
      fr_CA: 'Contactez votre administrateur',
      it_IT: 'Contatta il tuo amministratore',
      pl_PL: 'Skontaktuj się z administratorem',
      th_TH: 'ติดต่อผู้ดูแลระบบของคุณ',
      zh_CN: '請與您的管理員連絡',
      pt_BR: 'Entre em contato com seu administrador',
      ja_JP: '管理者に連絡する',
    },
    contactAdminDescription: {
      en_US: 'Your email account\'s password is maintained by your company\'s email administrator. Please contact them to retrieve or reset your password.',
      de_DE: 'Das Kennwort Ihres E-Mail-Kontos wird vom E-Mail-Administrator Ihres Unternehmens verwaltet. Wenden Sie sich an sie, um Ihr Kennwort abzurufen oder zurückzusetzen.',
      el_GR: 'Ο κωδικός πρόσβασης του λογαριασμού ηλεκτρονικού ταχυδρομείου σας διατηρείται από το διαχειριστή ηλεκτρονικού ταχυδρομείου της εταιρείας σας. Επικοινωνήστε μαζί τους για να ανακτήσετε ή να επαναφέρετε τον κωδικό πρόσβασής σας.',
      es_ES: 'El administrador de correo electrónico de su empresa mantiene la contraseña de su cuenta de correo electrónico. Póngase en contacto con ellos para recuperar o restablecer su contraseña.',
      fr_FR: 'Le mot de passe de votre compte de messagerie est maintenu par l’administrateur de messagerie de votre entreprise. Veuillez les contacter pour récupérer ou réinitialiser votre mot de passe.',
      fr_CA: 'Le mot de passe de votre compte de messagerie est maintenu par l’administrateur de messagerie de votre entreprise. Veuillez les contacter pour récupérer ou réinitialiser votre mot de passe.',
      it_IT: 'La password dell\'account e-mail viene gestita dall\'amministratore della posta elettronica dell\'azienda. Si prega di contattarli per recuperare o reimpostare la password.',
      pl_PL: 'Hasło konta e-mail jest obsługiwane przez administratora poczty e-mail firmy. Skontaktuj się z nimi, aby odzyskać lub zresetować hasło.',
      th_TH: 'รหัสผ่านของบัญชีอีเมลของคุณจะถูกดูแลโดยผู้ดูแลระบบอีเมลของบริษัทของคุณ กรุณาติดต่อพวกเขาเพื่อเรียกคืนหรือรีเซ็ตรหัสผ่านของคุณ',
      zh_CN: '電子郵件帳戶的密碼由公司的電子郵件管理員維護。請與他們聯繫以檢索或重置密碼。',
      pt_BR: 'A senha da sua conta de e-mail é mantida pelo administrador de e-mail da sua empresa. Entre em contato com eles para recuperar ou redefinir sua senha.',
      ja_JP: 'メール アカウントのパスワードは、会社の電子メール管理者によって管理されます。パスワードを取得またはリセットするには、連絡してください。',
    },
    continue: {
      en_US: 'Continue',
      de_DE: 'Fortsetzen',
      el_GR: 'Να συνεχίσει',
      es_ES: 'Seguir',
      fr_FR: 'Continuer',
      fr_CA: 'Continuer',
      it_IT: 'Continua',
      pl_PL: 'Kontyntynuj',
      th_TH: 'ต่อ',
      zh_CN: '繼續',
      pt_BR: 'Continuar',
      ja_JP: '継続する',
    },
    didntGetCode: {
      en_US: 'Didn\'t get the code?',
      de_DE: 'Haben Sie den Code nicht erhalten?',
      el_GR: 'Δεν πήρες τον κωδικό;',
      es_ES: '¿No conseguiste el código?',
      fr_FR: 'Vous n’avez pas eu le code ?',
      fr_CA: 'Vous n’avez pas eu le code ?',
      it_IT: 'Non hai preso il codice?',
      pl_PL: 'Nie otrzymałeś kodu?',
      th_TH: 'ไม่ได้รหัส?',
      zh_CN: '未獲取代碼?',
      pt_BR: 'Não conseguiu o código?',
      ja_JP: 'コードを取得しませんでしたか?',
    },
    emailAddress: {
      en_US: 'Email Address',
      de_DE: 'E-Mail-Adresse',
      el_GR: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου',
      es_ES: 'Dirección de correo electrónico',
      fr_FR: 'Adresse e-mail',
      fr_CA: 'Adresse e-mail',
      it_IT: 'indirizzo email',
      pl_PL: 'Adres e-mail',
      th_TH: 'ที่อยู่อีเมล',
      zh_CN: '電子郵件地址',
      pt_BR: 'Endereço de e-mail',
      ja_JP: 'メールアドレス',
    },
    'emailAddressRequiredMessage': {
      en_US: 'Email Address is required.',
      de_DE: 'E-Mail-Adresse ist erforderlich.',
      el_GR: 'Απαιτείται διεύθυνση ηλεκτρονικού ταχυδρομείου.',
      es_ES: 'Se requiere dirección de correo electrónico.',
      fr_FR: 'L’adresse e-mail est requise.',
      fr_CA: 'L’adresse e-mail est requise.',
      it_IT: 'L\'indirizzo e-mail è obbligatorio.',
      pl_PL: 'Wymagany jest adres e-mail.',
      th_TH: 'จําเป็นต้องใช้ที่อยู่อีเมล',
      zh_CN: '電子郵件地址是必需的。',
      pt_BR: 'O endereço de e-mail é necessário.',
      ja_JP: 'メールアドレスが必要です。',
    },
    'enterCodeBelow': {
      en_US: 'Enter the code from your authentication app below to confirm your account.',
      de_DE: 'Geben Sie den Code aus Ihrer Authentifizierungs-App unten ein, um Ihr Konto zu bestätigen.',
      el_GR: 'Εισαγάγετε τον κωδικό από την εφαρμογή ελέγχου ταυτότητας παρακάτω για να επιβεβαιώσετε το λογαριασμό σας.',
      es_ES: 'Introduce el código de la aplicación de autenticación a continuación para confirmar tu cuenta.',
      fr_FR: 'Entrez le code de votre application d’authentification ci-dessous pour confirmer votre compte.',
      fr_CA: 'Entrez le code de votre application d’authentification ci-dessous pour confirmer votre compte.',
      it_IT: 'Inserisci il codice dalla tua app di autenticazione qui sotto per confermare il tuo account.',
      pl_PL: 'Wpisz kod z aplikacji uwierzytelniajej poniżej, aby potwierdzić swoje konto.',
      th_TH: 'ป้อนรหัสจากการตรวจสอบสิทธิ์ของคุณด้านล่างเพื่อยืนยันบัญชีของคุณ',
      zh_CN: '輸入以下身份驗證應用的代碼以確認您的帳戶。',
      pt_BR: 'Digite o código do seu aplicativo de autenticação abaixo para confirmar sua conta.',
      ja_JP: '以下に認証アプリのコードを入力して、アカウントを確認してください。',
    },
    enterEmailAddress: {
      en_US: 'Enter Email Address',
      de_DE: 'E-Mail-Adresse eingeben',
      el_GR: 'Εισαγωγή διεύθυνσης ηλεκτρονικού ταχυδρομείου',
      es_ES: 'Introducir dirección de correo electrónico',
      fr_FR: 'Entrez l’adresse e-mail',
      fr_CA: 'Entrez l’adresse e-mail',
      it_IT: 'Inserisci indirizzo e-mail',
      pl_PL: 'Wprowadź adres e-mail',
      th_TH: 'ป้อนที่อยู่อีเมล',
      zh_CN: '輸入電子郵件地址',
      pt_BR: 'Digite endereço de e-mail',
      ja_JP: 'メールアドレスの入力',
    },
    enterVerificationCode: {
      en_US: 'Enter Verification Code',
      de_DE: 'Geben Sie den Bestätigungscode ein',
      el_GR: 'Εισαγωγή κωδικού επαλήθευσης',
      es_ES: 'Introduzca el código de verificación',
      fr_FR: 'Saisir le code de vérification',
      fr_CA: 'Saisir le code de vérification',
      it_IT: 'Inserisci il codice di verifica',
      pl_PL: 'Wprowadź kod weryfikacyjny',
      th_TH: 'ป้อนรหัสยืนยัน',
      zh_CN: '輸入驗證碼',
      pt_BR: 'Digite código de verificação',
      ja_JP: '確認コードの入力',
    },
    'errorResendCode': {
      en_US: 'We were unable to resend your code. Please try again.',
      de_DE: 'Sie konnten Ihren Code nicht erneut senden. Bitte versuchen Sie es erneut.',
      el_GR: 'Δεν μπορέσαμε να στείλουμε ξανά τον κωδικό σου. Προσπαθήστε ξανά.',
      es_ES: 'No hemos podido reenviar el código. Por favor, inténtelo de nuevo.',
      fr_FR: 'Nous n’avons pas pu renvoyer votre code. S’ll vous plaît, réessayez.',
      fr_CA: 'Nous n’avons pas pu renvoyer votre code. S’ll vous plaît, réessayez.',
      it_IT: 'Non è stato possibile inviare nuovamente il codice. Riprovare.',
      pl_PL: 'Nie udało nam się ponownie wysłać kodu. Spróbuj ponownie.',
      th_TH: 'เราไม่สามารถส่งรหัสของคุณอีกครั้งได้ กรุณาลองอีกครั้ง',
      zh_CN: '無法重新發送您的代碼。請重試。',
      pt_BR: 'Não pudemos reeender seu código. Por favor, tente de novo.',
      ja_JP: 'コードを再送信できませんでした。もう一度やり直してください。',
    },
    'errorSubmitChallengeResponse': {
      en_US: 'We were unable to verify your code. Please try again.',
      de_DE: 'Sie konnten Ihren Code nicht überprüfen. Bitte versuchen Sie es erneut.',
      el_GR: 'Δεν μπορέσαμε να επαληθεύσουμε τον κωδικό σας. Προσπαθήστε ξανά.',
      es_ES: 'No hemos podido verificar su código. Por favor, inténtelo de nuevo.',
      fr_FR: 'Nous n’avons pas été en mesure de vérifier votre code. S’ll vous plaît, réessayez.',
      fr_CA: 'Nous n’avons pas été en mesure de vérifier votre code. S’ll vous plaît, réessayez.',
      it_IT: 'Non è stato possibile verificare il codice. Riprovare.',
      pl_PL: 'Nie udało nam się zweryfikować twojego kodu. Spróbuj ponownie.',
      th_TH: 'เราไม่สามารถตรวจสอบรหัสของคุณ กรุณาลองอีกครั้ง',
      zh_CN: '我們無法驗證您的代碼。請重試。',
      pt_BR: 'Não pudemos verificar seu código. Por favor, tente de novo.',
      ja_JP: 'コードを確認できませんでした。もう一度やり直してください。',
    },
    'errorSubmitResetPassword': {
      en_US: 'We were unable to reset your password. Please try again.',
      de_DE: 'Ihr Kennwort konnte nicht zurückgesetzt werden. Bitte versuchen Sie es erneut.',
      el_GR: 'Δεν ήταν δυνατή η επαναφορά του κωδικού πρόσβασής σας. Προσπαθήστε ξανά.',
      es_ES: 'No hemos podido restablecer su contraseña. Por favor, inténtelo de nuevo.',
      fr_FR: 'Nous n’avons pas pu réinitialiser votre mot de passe. S’ll vous plaît, réessayez.',
      fr_CA: 'Nous n’avons pas pu réinitialiser votre mot de passe. S’ll vous plaît, réessayez.',
      it_IT: 'Non è stato possibile reimpostare la password. Riprovare.',
      pl_PL: 'Nie udało nam się zresetować hasła. Spróbuj ponownie.',
      th_TH: 'เราไม่สามารถรีเซ็ตรหัสผ่านของคุณได้ กรุณาลองอีกครั้ง',
      zh_CN: '我們無法重置您的密碼。請重試。',
      pt_BR: 'Não conseguimos redefinir sua senha. Por favor, tente de novo.',
      ja_JP: 'パスワードをリセットできませんでした。もう一度やり直してください。',
    },
    'errorSubmitAddress': {
      en_US: 'We were unable to submit a password reset request. Please try again.',
      de_DE: 'Wir konnten keine Anforderung zum Zurücksetzen des Kennworts senden. Bitte versuchen Sie es erneut.',
      el_GR: 'Δεν ήταν δυνατή η υποβολή αιτήματος επαναφοράς κωδικού πρόσβασης. Προσπαθήστε ξανά.',
      es_ES: 'No hemos podido enviar una solicitud de restablecimiento de contraseña. Por favor, inténtelo de nuevo.',
      fr_FR: 'Nous n’avons pas été en mesure de soumettre une demande de réinitialisation de mot de passe. S’ll vous plaît, réessayez.',
      fr_CA: 'Nous n’avons pas été en mesure de soumettre une demande de réinitialisation de mot de passe. S’ll vous plaît, réessayez.',
      it_IT: 'Non è stato possibile inviare una richiesta di reimpostazione della password. Riprovare.',
      pl_PL: 'Nie udało nam się przesłać żądania resetowania hasła. Spróbuj ponownie.',
      th_TH: 'เราไม่สามารถส่งคําขอรีเซ็ตรหัสผ่านได้ กรุณาลองอีกครั้ง',
      zh_CN: '無法提交密碼重置請求。請重試。',
      pt_BR: 'Não pudemos enviar uma solicitação de redefinição de senha. Por favor, tente de novo.',
      ja_JP: 'パスワードのリセット要求を送信できませんでした。もう一度やり直してください。',
    },
    'errorSubmitAddressAndPhoneNumber': {
      en_US: 'We were unable to verify the recovery phone number. Please try again.',
      de_DE: 'Die Telefonnummer der Wiederherstellung konnte nicht überprüft werden. Bitte versuchen Sie es erneut.',
      el_GR: 'Δεν μπορέσαμε να επαληθεύσουμε τον αριθμό τηλεφώνου ανάκτησης. Προσπαθήστε ξανά.',
      es_ES: 'No hemos podido verificar el número de teléfono de recuperación. Por favor, inténtelo de nuevo.',
      fr_FR: 'Nous n’avons pas été en mesure de vérifier le numéro de téléphone de récupération. S’ll vous plaît, réessayez.',
      fr_CA: 'Nous n’avons pas été en mesure de vérifier le numéro de téléphone de récupération. S’ll vous plaît, réessayez.',
      it_IT: 'Non è stato possibile verificare il numero di telefono di recupero. Riprovare.',
      pl_PL: 'Nie udało nam się zweryfikować numeru telefonu odzyskiwania. Spróbuj ponownie.',
      th_TH: 'เราไม่สามารถตรวจสอบหมายเลขโทรศัพท์การกู้คืนได้ กรุณาลองอีกครั้ง',
      zh_CN: '我們無法驗證恢復電話號碼。請重試。',
      pt_BR: 'Não pudemos verificar o número de telefone de recuperação. Por favor, tente de novo.',
      ja_JP: '回復用の電話番号を確認できませんでした。もう一度やり直してください。',
    },
    justSentCode: {
      en_US: 'We just sent a verification code to [phoneNumber]. Enter the code below to confirm your account.',
      de_DE: 'Wir haben gerade einen Verifizierungscode an [phoneNumber] gesendet. Geben Sie den Code unten ein, um Ihr Konto zu bestätigen.',
      el_GR: 'Μόλις στείλαμε έναν κωδικό επαλήθευσης στο [phoneNumber]. Εισαγάγετε τον παρακάτω κωδικό για να επιβεβαιώσετε το λογαριασμό σας.',
      es_ES: 'Acabamos de enviar un código de verificación a [phoneNumber]. Introduzca el siguiente código para confirmar su cuenta.',
      fr_FR: 'Nous venons d’envoyer un code de vérification à [phoneNumber]. Entrez le code ci-dessous pour confirmer votre compte.',
      fr_CA: 'Nous venons d’envoyer un code de vérification à [phoneNumber]. Entrez le code ci-dessous pour confirmer votre compte.',
      it_IT: 'Abbiamo appena inviato un codice di verifica a [phoneNumber]. Inserisci il codice qui sotto per confermare il tuo account.',
      pl_PL: 'Właśnie wysłaliśmy kod weryfikacyjny do [phoneNumber]. Wpisz poniższy kod, aby potwierdzić swoje konto.',
      th_TH: 'เราเพิ่งส่งรหัสยืนยันไปยัง [phoneNumber] ป้อนรหัสด้านล่างเพื่อยืนยันบัญชีของคุณ',
      zh_CN: '我們剛剛向 [電話號] 傳送了驗證碼。輸入以下代碼以確認您的帳戶。',
      pt_BR: 'Acabamos de enviar um código de verificação para [phoneNumber]. Digite o código abaixo para confirmar sua conta.',
      ja_JP: '確認コードを [phoneNumber] に送信しました。以下のコードを入力して、アカウントを確認してください。',
    },
    passwordRequestLimit: {
      en_US: 'Only one password reset attempt is allowed per hour',
      de_DE: 'Pro Stunde ist nur ein Kennwortrücksetzversuch zulässig.',
      el_GR: 'Επιτρέπεται μόνο μία προσπάθεια επαναφοράς κωδικού πρόσβασης ανά ώρα',
      es_ES: 'Solo se permite un intento de restablecimiento de contraseña por hora',
      fr_FR: 'Une seule tentative de réinitialisation de mot de passe est autorisée par heure',
      fr_CA: 'Une seule tentative de réinitialisation de mot de passe est autorisée par heure',
      it_IT: 'È consentito un solo tentativo di reimpostazione della password all\'ora',
      pl_PL: 'Tylko jedna próba zresetowania hasła jest dozwolona na godzinę',
      th_TH: 'อนุญาตให้มีความพยายามรีเซ็ตรหัสผ่านได้เพียงครั้งละหนึ่งครั้งเท่านั้น',
      zh_CN: '每小時只允許嘗試密碼重設',
      pt_BR: 'Apenas uma tentativa de redefinição de senha é permitida por hora',
      ja_JP: '1 時間に 1 回だけパスワードリセットを試行できます。',
    },
    passwordWasReset: {
      en_US: 'Your Password Has Been Reset',
      de_DE: 'Ihr Passwort wurde zurückgesetzt',
      el_GR: 'Ο κωδικός πρόσβασής σας έχει επαναρυθμιστεί',
      es_ES: 'Su contraseña ha sido restablecido',
      fr_FR: 'Votre mot de passe a été réinitialisé',
      fr_CA: 'Votre mot de passe a été réinitialisé',
      it_IT: 'La tua password è stata reimpostata',
      pl_PL: 'Twoje hasło zostało zresetowane',
      th_TH: 'รหัสผ่านของคุณถูกรีเซ็ต',
      zh_CN: '您的密碼已重置',
      pt_BR: 'Sua senha foi redefinida',
      ja_JP: 'パスワードがリセットされました',
    },
    phoneNumber: {
      en_US: 'Phone Number',
      de_DE: 'Telefonnummer',
      el_GR: 'Αριθμός τηλεφώνου',
      es_ES: 'Número de teléfono',
      fr_FR: 'Numéro de téléphone',
      fr_CA: 'Numéro de téléphone',
      it_IT: 'Numero di telefono',
      pl_PL: 'Numer telefonu',
      th_TH: 'หมายเลขโทรศัพท์',
      zh_CN: '電話號碼',
      pt_BR: 'Número de telefone',
      ja_JP: '電話番号',
    },
    'phoneNumberRequiredMessage': {
      en_US: 'Phone Number is required.',
      de_DE: 'Telefonnummer ist erforderlich.',
      el_GR: 'Απαιτείται αριθμός τηλεφώνου.',
      es_ES: 'Se requiere el número de teléfono.',
      fr_FR: 'Le numéro de téléphone est requis.',
      fr_CA: 'Le numéro de téléphone est requis.',
      it_IT: 'Il numero di telefono è obbligatorio.',
      pl_PL: 'Numer telefonu jest wymagany.',
      th_TH: 'หมายเลขโทรศัพท์เป็นสิ่งจําเป็น',
      zh_CN: '電話號碼是必需的。',
      pt_BR: 'Número de telefone é necessário.',
      ja_JP: '電話番号が必要です。',
    },
    providePhoneNumber: {
      en_US: 'This email address is associated with the mobile phone number ending with [lastTwoDigits]. Please enter your full mobile phone number below so we can text you a recover code.',
      de_DE: 'Diese E-Mail-Adresse ist mit der Mobiltelefonnummer verknüpft, die mit [lastTwoDigits] endet. Bitte geben Sie unten Ihre vollständige Mobiltelefonnummer ein, damit wir Ihnen einen Wiederherstellungscode mit teilen können.',
      el_GR: 'Αυτή η διεύθυνση ηλεκτρονικού ταχυδρομείου σχετίζεται με τον αριθμό κινητού τηλεφώνου που τελειώνει με [lastTwoDigits]. Παρακαλώ εισάγετε τον πλήρη αριθμό του κινητού σας τηλεφώνου παρακάτω ώστε να μπορούμε να σας κείμενο ένα κωδικό ανάκτησης.',
      es_ES: 'Esta dirección de correo electrónico está asociada con el número de teléfono móvil que termina con [lastTwoDigits]. Por favor, introduzca su número de teléfono móvil completo a continuación para que podamos enviarle un código de recuperación por mensaje de texto.',
      fr_FR: 'Cette adresse e-mail est associée au numéro de téléphone mobile se terminant par [lastTwoDigits]. S’il vous plaît entrez votre numéro de téléphone mobile complet ci-dessous afin que nous puissions vous envoyer un code de récupération.',
      fr_CA: 'Cette adresse e-mail est associée au numéro de téléphone mobile se terminant par [lastTwoDigits]. S’il vous plaît entrez votre numéro de téléphone mobile complet ci-dessous afin que nous puissions vous envoyer un code de récupération.',
      it_IT: 'Questo indirizzo e-mail è associato al numero di cellulare che termina con [lastTwoDigits]. Inserisci il tuo numero di cellulare completo qui sotto in modo che possiamo inviarvi un codice di recupero.',
      pl_PL: 'Ten adres e-mail jest skojarzony z numerem telefonu komórkowego kończącym się na [lastTwoDigits]. Podaj poniżej pełny numer telefonu komórkowego, abyśmy mogli wysłać ci kod odzyskiwania.',
      th_TH: 'ที่อยู่อีเมลนี้เชื่อมโยงกับหมายเลขโทรศัพท์มือถือที่ลงท้ายด้วย [lastTwoDigits] กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณด้านล่างเพื่อให้เราสามารถส่งข้อความหาคุณรหัสกู้คืน',
      zh_CN: '此電子郵件地址與以 [上雙位數位] 結尾的手機號碼相關聯。請在下面輸入您的完整手機號碼,以便我們為您發送恢復代碼。',
      pt_BR: 'Este endereço de e-mail está associado com o número de telefone celular terminando com [lastTwoDigits]. Por favor, digite seu número completo de telefone celular abaixo para que possamos enviar um código de recuperação.',
      ja_JP: 'この電子メール アドレスは、[lastTwoDigits] で終わる携帯電話番号に関連付けられます。私たちはあなたに回復コードをテキストできるように、以下にあなたの完全な携帯電話番号を入力してください。',
    },
    resetPassword: {
      en_US: 'Reset Password',
      de_DE: 'Zurücksetzen des Kennworts',
      el_GR: 'Επαναφορά κωδικού πρόσβασης',
      es_ES: 'Restablecer contraseña',
      fr_FR: 'Mot de passe réinitialisé',
      fr_CA: 'Mot de passe réinitialisé',
      it_IT: 'Reimposta password',
      pl_PL: 'Resetowanie hasła',
      th_TH: 'รีเซ็ตรหัสผ่าน',
      zh_CN: '重設密碼',
      pt_BR: 'Redefinir senha',
      ja_JP: 'パスワードのリセット',
    },
    resetYourPassword: {
      en_US: 'Reset Your Password',
      de_DE: 'Zurücksetzen Ihres Passworts',
      el_GR: 'Επαναφορά του κωδικού πρόσβασής σας',
      es_ES: 'Restablecer su contraseña',
      fr_FR: 'Réinitialisez votre mot de passe',
      fr_CA: 'Réinitialisez votre mot de passe',
      it_IT: 'Reimpostare la password',
      pl_PL: 'Resetowanie hasła',
      th_TH: 'รีเซ็ตรหัสผ่านของคุณ',
      zh_CN: '重設密碼',
      pt_BR: 'Redefinir sua senha',
      ja_JP: 'パスワードをリセットする',
    },
    successfullyVerifiedPassword: {
      en_US: 'You have successfully verified your account. Enter a new password below.',
      de_DE: 'Sie haben Ihr Konto erfolgreich verifiziert. Geben Sie unten ein neues Kennwort ein.',
      el_GR: 'Επαληθεύσατε με επιτυχία το λογαριασμό σας. Πληκτρολογήστε έναν νέο κωδικό πρόσβασης παρακάτω.',
      es_ES: 'Has verificado correctamente tu cuenta. Introduzca una nueva contraseña a continuación.',
      fr_FR: 'Vous avez vérifié avec succès votre compte. Entrez un nouveau mot de passe ci-dessous.',
      fr_CA: 'Vous avez vérifié avec succès votre compte. Entrez un nouveau mot de passe ci-dessous.',
      it_IT: 'Hai verificato correttamente il tuo account. Immettere una nuova password di seguito.',
      pl_PL: 'Twoje konto zostało pomyślnie zweryfikowane. Wprowadź nowe hasło poniżej.',
      th_TH: 'คุณได้ยืนยันบัญชีของคุณเรียบร้อยแล้ว ป้อนรหัสผ่านใหม่ด้านล่าง',
      zh_CN: '您已成功驗證您的帳戶。請在下面輸入新密碼。',
      pt_BR: 'Você verificou com sucesso sua conta. Digite uma nova senha abaixo.',
      ja_JP: 'アカウントの確認が完了しました。新しいパスワードを入力してください。',
    },
    submitEmailAddress: {
      en_US: 'Submit your full email address to determine which password reset options are available for your account.',
      de_DE: 'Senden Sie Ihre vollständige E-Mail-Adresse, um zu bestimmen, welche Optionen zum Zurücksetzen von Kennwörtern für Ihr Konto verfügbar sind.',
      el_GR: 'Υποβάλετε την πλήρη διεύθυνση ηλεκτρονικού ταχυδρομείου σας για να προσδιορίσετε ποιες επιλογές επαναφοράς κωδικού πρόσβασης είναι διαθέσιμες για το λογαριασμό σας.',
      es_ES: 'Envíe su dirección de correo electrónico completa para determinar qué opciones de restablecimiento de contraseña están disponibles para su cuenta.',
      fr_FR: 'Soumettez votre adresse e-mail complète pour déterminer quelles options de réinitialisation de mot de passe sont disponibles pour votre compte.',
      fr_CA: 'Soumettez votre adresse e-mail complète pour déterminer quelles options de réinitialisation de mot de passe sont disponibles pour votre compte.',
      it_IT: 'Invia il tuo indirizzo email completo per determinare quali opzioni di reimpostazione della password sono disponibili per il tuo account.',
      pl_PL: 'Prześlij pełny adres e-mail, aby określić, które opcje resetowania hasła są dostępne dla Twojego konta.',
      th_TH: 'ส่งที่อยู่อีเมลแบบเต็มของคุณเพื่อกําหนดว่าตัวเลือกการรีเซ็ตรหัสผ่านใดที่ใช้ได้กับบัญชีของคุณ',
      zh_CN: '提交您的完整電子郵寄地址,以確定您的帳戶可以使用哪些密碼重置選項。',
      pt_BR: 'Envie seu endereço de e-mail completo para determinar quais opções de redefinição de senha estão disponíveis para sua conta.',
      ja_JP: '完全なメールアドレスを送信して、アカウントで使用できるパスワードリセットオプションを確認します。',
    },
    textRatesApply: {
      en_US: 'Standard SMS rates apply',
      de_DE: 'Es gelten Standard-SMS-Tarife',
      el_GR: 'Ισχύουν τυπικές τιμές SMS',
      es_ES: 'Se aplican tarifas estándar por SMS',
      fr_FR: 'Les taux de SMS standard s’appliquent',
      fr_CA: 'Les taux de SMS standard s’appliquent',
      it_IT: 'Si applicano tariffe SMS standard',
      pl_PL: 'Obowiązują standardowe stawki SMS',
      th_TH: 'อัตรา SMS มาตรฐานใช้บังคับ',
      zh_CN: '適用標準簡訊費率',
      pt_BR: 'Taxas padrão de SMS se aplicam',
      ja_JP: '標準 SMS 料金が適用されます',
    },
    updateClients: {
      en_US: 'Don\'t forget to update your password in any email programs you use on your computer or mobile device.',
      de_DE: 'Vergessen Sie nicht, Ihr Passwort in allen E-Mail-Programmen zu aktualisieren, die Sie auf Ihrem Computer oder Mobilgerät verwenden.',
      el_GR: 'Μην ξεχάσετε να ενημερώσετε τον κωδικό πρόσβασής σας σε οποιαδήποτε προγράμματα ηλεκτρονικού ταχυδρομείου που χρησιμοποιείτε στον υπολογιστή ή την κινητή συσκευή σας.',
      es_ES: 'No olvides actualizar tu contraseña en cualquier programa de correo electrónico que uses en tu ordenador o dispositivo móvil.',
      fr_FR: 'N’oubliez pas de mettre à jour votre mot de passe dans tous les programmes de messagerie que vous utilisez sur votre ordinateur ou appareil mobile.',
      fr_CA: 'N’oubliez pas de mettre à jour votre mot de passe dans tous les programmes de messagerie que vous utilisez sur votre ordinateur ou appareil mobile.',
      it_IT: 'Non dimenticare di aggiornare la password in qualsiasi programma di posta elettronica che utilizzi sul tuo computer o dispositivo mobile.',
      pl_PL: 'Nie zapomnij zaktualizować hasła w programach poczty e-mail używanych na komputerze lub urządzeniu mobilnym.',
      th_TH: 'อย่าลืมอัปเดตรหัสผ่านของคุณในโปรแกรมอีเมลที่คุณใช้บนคอมพิวเตอร์หรืออุปกรณ์เคลื่อนที่ของคุณ',
      zh_CN: '不要忘記在電腦或行動裝置上使用的任何電子郵件程式中更新密碼。',
      pt_BR: 'Não se esqueça de atualizar sua senha em qualquer programa de e-mail que você usa em seu computador ou dispositivo móvel.',
      ja_JP: 'パソコンやモバイルデバイスで使用するメールプログラムでパスワードを更新することを忘れないでください。',
    },
    'passwordRecovery': {
      en_US: 'Webmail Password Recovery',
      de_DE: 'Webmail-Kennwortwiederherstellung',
      el_GR: 'Ανάκτηση κωδικού πρόσβασης webmail',
      es_ES: 'Recuperación de contraseña de Webmail',
      fr_FR: 'Récupération de mot de passe Webmail',
      fr_CA: 'Récupération de mot de passe Webmail',
      it_IT: 'Recupero password Webmail',
      pl_PL: 'Odzyskiwanie hasła poczty internetowej',
      th_TH: 'การกู้คืนรหัสผ่านเว็บเมล',
      zh_CN: '網路郵件密碼恢復。',
      pt_BR: 'Recuperação de senhas do Webmail',
      ja_JP: 'ウェブメールのパスワードの回復',
    },
    verifyMobilePhone: {
      en_US: 'Verify Mobile Phone',
      de_DE: 'Überprüfen des Mobiltelefons',
      el_GR: 'Επαλήθευση κινητού τηλεφώνου',
      es_ES: 'Verificar teléfono móvil',
      fr_FR: 'Vérifier téléphone mobile',
      fr_CA: 'Vérifier téléphone mobile',
      it_IT: 'Verificare il telefono cellulare',
      pl_PL: 'Weryfikuj telefon komórkowy',
      th_TH: 'ยืนยันโทรศัพท์มือถือ',
      zh_CN: '驗證行動電話',
      pt_BR: 'Verifique o celular',
      ja_JP: '携帯電話の確認',
    },
    verificationCode: {
      en_US: 'Verification Code',
      de_DE: 'Verifizierungscode',
      el_GR: 'Κωδικός επαλήθευσης',
      es_ES: 'Código de verificación',
      fr_FR: 'Code de vérification',
      fr_CA: 'Code de vérification',
      it_IT: 'Codice di verifica',
      pl_PL: 'Código de verificação',
      th_TH: 'รหัสยืนยัน',
      zh_CN: '驗證碼',
      pt_BR: 'Código de verificação',
      ja_JP: '確認コード',
    },
    'verificationCodeRequiredMessage': {
      en_US: 'Verification Code is required.',
      de_DE: 'Überprüfungscode ist erforderlich.',
      el_GR: 'Απαιτείται κωδικός επαλήθευσης.',
      es_ES: 'Se requiere código de verificación.',
      fr_FR: 'Le Code de vérification est requis.',
      fr_CA: 'Le Code de vérification est requis.',
      it_IT: 'Il codice di verifica è obbligatorio.',
      pl_PL: 'Wymagany jest kod weryfikacyjny.',
      th_TH: 'ต้องระบุรหัสยืนยัน',
      zh_CN: '需要驗證代碼。',
      pt_BR: 'O Código de Verificação é necessário.',
      ja_JP: '確認コードが必要です。',
    },
  };

  return mapping[key][lang];
};
